// ProfileManager.js — Thematic Pilot Callsign & Local Profile System

const PREFIXES = [
  'CYBER', 'NEON', 'TURBO', 'HYPER', 'LASER', 'RETRO', 'QUANTUM', 'SOLAR',
  'SHADOW', 'COBALT', 'VECTOR', 'VORTEX', 'CHROMA', 'SONIC', 'TITAN', 'VOLT',
  'PIXEL', 'ARCADE', 'COSMIC', 'PULSE', 'SYNTH', 'STEALTH', 'APEX', 'OMEGA',
  'ZERO', 'PROTO', 'RADICAL', 'GLITCH', 'ATOMIC', 'NEXUS', 'FROST', 'BLAZE'
];

const CORES = [
  'BREAKER', 'STRIKER', 'PILOT', 'RUNNER', 'VIPER', 'DRIFTER', 'CRUSHER',
  'BLASTER', 'PHANTOM', 'RAIDER', 'KNIGHT', 'WARP', 'STORM', 'SPARK',
  'HUNTER', 'COMMANDER', 'NEXUS', 'HAWK', 'VOYAGER', 'CYPHER', 'SURGE',
  'ACE', 'GRID', 'SPECTRE', 'CORSAIR', 'OVERDRIVE', 'MATRIX'
];

export class ProfileManager {
  constructor() {
    this.username = this.loadUsername();
  }

  generateRandomUsername() {
    const prefix = PREFIXES[Math.floor(Math.random() * PREFIXES.length)];
    const core = CORES[Math.floor(Math.random() * CORES.length)];
    const tag = Math.floor(Math.random() * 99) + 1;
    const tagStr = String(tag).padStart(2, '0');
    return `${prefix}-${core} #${tagStr}`;
  }

  loadUsername() {
    try {
      let saved = localStorage.getItem('bricksYoUsername');
      if (!saved || saved.trim() === '') {
        saved = this.generateRandomUsername();
        localStorage.setItem('bricksYoUsername', saved);
      }
      return saved;
    } catch {
      return this.generateRandomUsername();
    }
  }

  rerollUsername() {
    const newName = this.generateRandomUsername();
    this.username = newName;
    try {
      localStorage.setItem('bricksYoUsername', newName);
    } catch {}
    return newName;
  }

  setUsername(customName) {
    if (!customName || typeof customName !== 'string') return this.username;
    const trimmed = customName.trim().toUpperCase().slice(0, 24);
    if (trimmed.length > 0) {
      this.username = trimmed;
      try {
        localStorage.setItem('bricksYoUsername', this.username);
      } catch {}
    }
    return this.username;
  }
}
